import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeliverooComponent } from './simple-icons-deliveroo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeliverooComponent ],
    exports:      [ SimpleIconsDeliverooComponent ],
    bootstrap:    []
})
export class SimpleIconsDeliverooModule {}
